export const URL_DATE_FORMAT = 'YYYY-MM-DD';